export interface HeroImage {
  src: string
  alt: string
}

const STRAPI_FALLBACK_BASE_URL = 'http://localhost:1337'

export const getMediaUrl = (media: any) => {
  const base = process.env.REACT_APP_STRAPI_ENDPOINT || STRAPI_FALLBACK_BASE_URL
  const raw = media?.url || media?.data?.attributes?.url || media?.attributes?.url || ''

  if (!raw) return ''
  if (raw.startsWith('http')) return raw

  return `${base}${raw}`
}

export const normalizeHeroImages = (hero: any, fallbackAltPrefix: string): HeroImage[] => {
  if (!hero) return []

  const toImage = (item: any, index: number): HeroImage | null => {
    const src = getMediaUrl(item)
    if (!src) return null

    const alt = item?.alternativeText || item?.name || `${fallbackAltPrefix} ${index + 1}`
    return { src, alt }
  }

  if (Array.isArray(hero)) {
    return hero
      .map((item: any, index: number) => toImage(item, index))
      .filter((image: HeroImage | null): image is HeroImage => image !== null)
  }

  if (Array.isArray(hero?.data)) {
    return hero.data
      .map((item: any, index: number) => toImage(item, index))
      .filter((image: HeroImage | null): image is HeroImage => image !== null)
  }

  const single = toImage(hero?.data || hero, 0)
  return single ? [single] : []
}
